import { useState } from "react";
import Stamp from "../../models/stamp";
import { CCard, CCardBody, CCardHeader, CCollapse } from "@coreui/react";

import StampCrudActions from "./StampCrudActions";
import { formatUTCDateTime } from "../../utils/dates";

interface StampCardProps {
  stamp: Stamp;
  onUpdateClick: (inv: Stamp) => void;
  onDeleteClick: (inv: Stamp) => void;
  isDemo?: boolean;
}

export function StampCard({
  stamp,
  onUpdateClick,
  onDeleteClick,
  isDemo,
}: StampCardProps) {
  const [open, setOpen] = useState(true);

  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{stamp.identifier}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{""}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1 border border-dark"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Fecha de Inicio:</strong>{" "}
            {formatUTCDateTime(new Date(stamp.beginDate!))}
          </p>

          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <StampCrudActions
              stamp={stamp}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
              isDemo={isDemo}
            />
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
